import { settings, saveSettings } from "./settings";
import { audio } from "../render/audio";

// A small settings popover shared by the main menu and the in-game HUD.
// Screen-shake toggle, SFX volume, mute. Purely UI-side.

const CSS = `
.settings-pop { position:fixed; z-index:120; width:250px; background:#0c1219f2; border:1px solid #24343f;
  border-radius:10px; padding:16px 16px 14px; box-shadow:0 18px 50px -12px #000c, 0 0 0 1px #0006;
  font-family:"Segoe UI",Arial,sans-serif; color:#dfe8ef; backdrop-filter:blur(6px); }
.settings-pop h3 { margin:0 0 12px; font-size:11px; letter-spacing:3px; color:#7f96a8; font-weight:600; }
.settings-row { display:flex; align-items:center; justify-content:space-between; margin:11px 0; font-size:13px; }
.settings-row label { color:#c5d2dc; letter-spacing:.5px; }
.sw { position:relative; width:40px; height:22px; border-radius:11px; background:#1b2731; border:1px solid #2b3b47;
  cursor:pointer; transition:.15s; flex:0 0 auto; }
.sw.on { background:#16465a; border-color:#40e0ff; }
.sw::after { content:""; position:absolute; top:2px; left:2px; width:16px; height:16px; border-radius:50%;
  background:#8595a2; transition:.15s; }
.sw.on::after { left:20px; background:#40e0ff; box-shadow:0 0 8px #40e0ff; }
.settings-pop input[type=range] { -webkit-appearance:none; appearance:none; width:120px; height:4px; border-radius:3px;
  background:#243441; outline:none; }
.settings-pop input[type=range]::-webkit-slider-thumb { -webkit-appearance:none; width:14px; height:14px; border-radius:50%;
  background:#40e0ff; cursor:pointer; box-shadow:0 0 6px #40e0ff88; }
.settings-pop .close { margin-top:8px; width:100%; background:#12202b; color:#dfe8ef; border:1px solid #2b3b47;
  padding:7px; border-radius:6px; cursor:pointer; letter-spacing:1px; font-size:12px; }
.settings-pop .close:hover { border-color:#40e0ff; }
`;

let open: HTMLDivElement | null = null;

function ensureStyle(): void {
  if (document.getElementById("settings-style")) return;
  const st = document.createElement("style");
  st.id = "settings-style";
  st.textContent = CSS;
  document.head.appendChild(st);
}

export function closeSettings(): void {
  open?.remove();
  open = null;
  document.removeEventListener("pointerdown", onDocDown, true);
}

function onDocDown(e: PointerEvent): void {
  if (open && !open.contains(e.target as Node)) closeSettings();
}

/** Toggle a settings popover anchored near the given screen point (top-right). */
export function toggleSettings(anchorRight: number, anchorTop: number): void {
  if (open) { closeSettings(); return; }
  ensureStyle();
  audio.unlock();
  const pop = document.createElement("div");
  pop.className = "settings-pop panel";
  pop.style.right = anchorRight + "px";
  pop.style.top = anchorTop + "px";
  pop.innerHTML = `
    <h3>SETTINGS</h3>
    <div class="settings-row">
      <label>Screen shake</label>
      <div class="sw ${settings.shake ? "on" : ""}" data-k="shake"></div>
    </div>
    <div class="settings-row">
      <label>Mute audio</label>
      <div class="sw ${settings.muted ? "on" : ""}" data-k="muted"></div>
    </div>
    <div class="settings-row">
      <label>SFX volume</label>
      <input type="range" min="0" max="100" value="${Math.round(settings.sfxVolume * 100)}" data-k="vol"/>
    </div>
    <button class="close">CLOSE</button>
  `;
  document.body.appendChild(pop);
  open = pop;

  for (const sw of Array.from(pop.querySelectorAll(".sw")) as HTMLDivElement[]) {
    sw.onclick = () => {
      const k = sw.dataset.k as "shake" | "muted";
      settings[k] = !settings[k];
      sw.classList.toggle("on", settings[k]);
      audio.refreshVolume();
      saveSettings();
      if (k === "muted" && !settings.muted) audio.ui("click");
    };
  }
  const vol = pop.querySelector('input[data-k="vol"]') as HTMLInputElement;
  vol.oninput = () => {
    settings.sfxVolume = Number(vol.value) / 100;
    audio.refreshVolume();
  };
  vol.onchange = () => { saveSettings(); audio.ui("click"); };
  (pop.querySelector(".close") as HTMLButtonElement).onclick = () => closeSettings();

  // Defer to avoid catching the same click that opened it.
  setTimeout(() => document.addEventListener("pointerdown", onDocDown, true), 0);
}
